import { defineComponent as l, ref as s, onMounted as h, onUnmounted as d, openBlock as f, createElementBlock as u, normalizeClass as m } from "vue";
import { _ as v } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './css/AnchorLine.css';const p = ["id"], y = /* @__PURE__ */ l({
  __name: "AnchorLine",
  props: {
    /**
     * The anchor ID for navigation. Used as the target for #anchor links.
     */
    anchor: {
      type: String,
      required: !0
    },
    /**
     * When true, the anchor has zero height (anchor target only, no visible line).
     * Use this when nesting inside a section-container.
     * @default false
     */
    inline: {
      type: Boolean,
      default: !1
    },
    /**
     * When true, the anchor line sticks to the top of the viewport when scrolled.
     * @default false
     */
    sticky: {
      type: Boolean,
      default: !1
    },
    /**
     * The color variant of the line.
     * - primary: Yellow/primary background (like hero bottomline)
     * - accent: Accent color background
     * - muted: Muted/gray background
     * - default: Default contrast color
     * - invisible: Transparent (anchor only, no visible line)
     *
     * @default 'primary'
     */
    variant: {
      type: String,
      default: "primary"
    },
    /**
     * If true, emits 'anchor:enter' event when element enters viewport.
     */
    enter: {
      type: Boolean,
      default: !1
    },
    /**
     * If true, emits 'anchor:exit' event when element exits viewport.
     */
    exit: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["anchor:enter", "anchor:exit"],
  setup(n, { emit: c }) {
    const e = n, t = s(null);
    let r = null;
    const a = c;
    return h(() => {
      !e.enter && !e.exit || t.value && (r = new IntersectionObserver(
        (i) => {
          for (const o of i)
            o.isIntersecting && e.enter ? (a("anchor:enter", e.anchor), window.dispatchEvent(new CustomEvent("anchorEnter", { detail: { anchor: e.anchor } }))) : !o.isIntersecting && e.exit && (a("anchor:exit", e.anchor), window.dispatchEvent(new CustomEvent("anchorExit", { detail: { anchor: e.anchor } })));
        },
        {
          threshold: 0.5,
          rootMargin: "0px"
        }
      ), r.observe(t.value));
    }), d(() => {
      r && t.value && (r.unobserve(t.value), r.disconnect());
    }), (i, o) => (f(), u("div", {
      ref_key: "anchorEl",
      ref: t,
      id: n.anchor,
      class: m(["anchor-line", [`anchor-line--${n.variant}`, { "anchor-line--inline": n.inline, "anchor-line--sticky": n.sticky }]])
    }, null, 10, p));
  }
}), w = /* @__PURE__ */ v(y, [["__scopeId", "data-v-3737221d"]]);
export {
  w as default
};
